import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSleep: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSleep"><Path fillRule="evenodd" clipRule="evenodd" d="M11 2H16.5V3.74142L12.8553 7.5H16.5V9H11V7.25858L14.6447 3.5H11V2ZM3 8H9V9.85574L4.71299 14.5H9V16H3V14.1443L7.28701 9.5H3V8ZM12 12H20V13.6431L13.8825 20.5H20V22H12V20.3569L18.1175 13.5H12V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSleep;
